module.exports = __webpack_public_path__ + "img/ZZRY_5.54fc07f8.jpg";